import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import PropTypes from 'prop-types';

class Jumbo extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            opacity: 'tw-opacity-100',
        };
        this.listenScrollEvent = this.listenScrollEvent.bind(this);
    }

    listenScrollEvent()
    {
        if (window.scrollY > 50 && this.props.vanish)
        {
            this.setState({ opacity: 'tw-opacity-0' });
        }
        else
        {
            this.setState({ opacity: 'tw-opacity-100' });
        }
    }

    componentDidMount()
    {
        window.addEventListener('scroll', this.listenScrollEvent);
    }

    componentWillUnmount()
    {
        window.removeEventListener('scroll', this.listenScrollEvent);
    }

    render()
    {
        const {
            image, title, subtitle, className,
        } = this.props;

        let [
            renderSubtitle, renderImageInfo,
        ] = '';

        if (title || subtitle)
        {
            if (subtitle)
            {
                renderSubtitle = <h4 className="tw-text-white tw-font-normal font-sp tw-uppercase tw-mt-3">{subtitle}</h4>;
            }
            renderImageInfo = (
                <div className={`tw-bg-gray-900 tw-bg-opacity-75 tw-py-4 tw-px-10 tw-mb-4 tw-mt-4 ${this.state.opacity}`}>
                    <h3 className="tw-text-white tw-font-normal font-arapey tw-text-2xl">{title}</h3>
                    {renderSubtitle}
                </div>
            );
        }

        return (
            <div className={className}>
                <div
                    className="tw-h-screen tw-bg-cover tw-bg-center tw-flex tw-items-center tw-flex-wrap tw-text-center tw-justify-center tw-bg-gray-700"
                    style={{ backgroundImage: `url(${image})` }}
                >
                    <Fade bottom>
                        <div>
                            <div className={`tw-h-10 tw-w-6 tw-rounded-full tw-border-solid tw-border-2 tw-border-white tw-m-auto tw-relative tw-hidden lg:tw-inline-block ${this.state.opacity}`}>
                                <span className="mouse-scroll tw-rounded-full tw-rounded-full tw-h-2 tw-w-1 tw-bg-white tw-inline-block tw-align-middle" />
                            </div>
                            {renderImageInfo}
                        </div>
                    </Fade>
                </div>
            </div>
        );
    }
}

Jumbo.defaultProps = {
    className: '',
};

Jumbo.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.oneOfType(
        [
            PropTypes.string,
            PropTypes.object,
        ],
    ),
    vanish: PropTypes.bool,
    className: PropTypes.string,
};

export default Jumbo;
